import React, { useState } from 'react';
import { FileTextIcon, EditIcon, UsersIcon, ArrowRightLeftIcon, BanknoteIcon, DownloadIcon, SearchIcon, ArrowRightIcon } from 'lucide-react';
import { servicesData } from '../data/sampleData';
import { Modal } from '../components/Modal';
interface ServicesPageProps {
  navigate: (page: string) => void;
  t: (key: string) => string;
  lands: any[];
}
export function ServicesPage({
  navigate,
  t,
  lands
}: ServicesPageProps) {
  const [selectedService, setSelectedService] = useState<any>(null);
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'FileTextIcon':
        return <FileTextIcon className="w-6 h-6" data-id="element-754" />;
      case 'EditIcon':
        return <EditIcon className="w-6 h-6" data-id="element-755" />;
      case 'UsersIcon':
        return <UsersIcon className="w-6 h-6" data-id="element-756" />;
      case 'ArrowRightLeftIcon':
        return <ArrowRightLeftIcon className="w-6 h-6" data-id="element-757" />;
      case 'BanknoteIcon':
        return <BanknoteIcon className="w-6 h-6" data-id="element-758" />;
      case 'DownloadIcon':
        return <DownloadIcon className="w-6 h-6" data-id="element-759" />;
      case 'SearchIcon':
        return <SearchIcon className="w-6 h-6" data-id="element-760" />;
      default:
        return <FileTextIcon className="w-6 h-6" data-id="element-761" />;
    }
  };
  return <div className="space-y-6 pb-20 lg:pb-6" data-id="element-762">
      <div data-id="element-763">
        <h2 className="text-2xl font-bold text-slate-800" data-id="element-764">
          {t('services.title')}
        </h2>
        <p className="text-slate-500" data-id="element-765">{t('services.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-766">
        {servicesData.map(service => <div key={service.id} onClick={() => setSelectedService(service)} className={`bg-white rounded-xl border p-5 sm:p-6 cursor-pointer transition-all hover:shadow-md group flex flex-col h-full
              ${service.status === 'action_needed' ? 'border-amber-300 shadow-sm' : 'border-slate-200 hover:border-[#006A4E]/30'}
            `} data-id="element-767">
            <div className="flex justify-between items-start mb-4" data-id="element-768">
              <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shrink-0
                ${service.status === 'action_needed' ? 'bg-amber-100 text-amber-600' : 'bg-slate-100 text-[#006A4E] group-hover:bg-[#006A4E]/10'}
              `} data-id="element-769">
                {getIcon(service.icon)}
              </div>

              {service.count && <span className={`px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold whitespace-nowrap ml-2
                  ${service.status === 'action_needed' ? 'bg-amber-100 text-amber-700' : 'bg-blue-100 text-blue-700'}
                `} data-id="element-770">
                  {service.count}{' '}
                  {service.status === 'action_needed' ? t('status.due') : t('status.active')}
                </span>}
            </div>

            <h3 className="text-base sm:text-lg font-bold text-slate-800 mb-2" data-id="element-771">
              {service.name}
            </h3>
            <p className="text-xs sm:text-sm text-slate-500 flex-1" data-id="element-772">
              {service.description}
            </p>

            <div className="mt-4 pt-4 border-t border-slate-100 flex items-center text-xs sm:text-sm font-medium text-[#006A4E] group-hover:translate-x-1 transition-transform" data-id="element-773">
              {service.status === 'in_progress' ? 'View Status' : 'Start Application'}{' '}
              <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-774" />
            </div>
          </div>)}
      </div>

      {/* Service Action Modal */}
      <Modal isOpen={!!selectedService} onClose={() => setSelectedService(null)} title={selectedService?.name || 'Service'} footer={<>
            <button onClick={() => setSelectedService(null)} className="px-4 py-2 text-slate-600 font-medium hover:bg-slate-100 rounded-lg text-sm" data-id="element-776">
              {t('common.cancel')}
            </button>
            <button onClick={() => {
        alert(`${selectedService?.name} initiated.`);
        setSelectedService(null);
      }} className="bg-[#006A4E] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#00523c] text-sm" data-id="element-777">
              {t('common.submit')}
            </button>
          </>} data-id="element-775">
        <div className="py-4" data-id="element-778">
          {selectedService?.id === 'svc-5' ?
        // Tax Payment specific content
        <div className="space-y-4" data-id="element-779">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6" data-id="element-780">
                <h4 className="font-bold text-amber-800 mb-1" data-id="element-781">
                  Unpaid Tax Detected
                </h4>
                <p className="text-sm text-amber-700" data-id="element-782">
                  You have 1 property with unpaid land development tax for the
                  current fiscal year.
                </p>
              </div>
              <div className="border border-slate-200 rounded-lg p-4 flex justify-between items-center" data-id="element-783">
                <div data-id="element-784">
                  <p className="font-bold text-slate-800" data-id="element-785">LAND-002</p>
                  <p className="text-sm text-slate-500" data-id="element-786">
                    {t('land.dag')} 457, Jamalpur, Gazipur
                  </p>
                </div>
                <div className="text-right" data-id="element-787">
                  <p className="font-bold text-lg text-slate-900" data-id="element-788">৳ 500</p>
                  <p className="text-xs text-slate-500" data-id="element-789">Due: 30 Mar 2026</p>
                </div>
              </div>
            </div> : selectedService?.id === 'svc-7' ?
        // Tracking specific content
        <div className="space-y-6" data-id="element-790">
              <div className="border border-slate-200 rounded-lg p-4" data-id="element-791">
                <div className="flex justify-between items-start mb-4" data-id="element-792">
                  <div data-id="element-793">
                    <span className="px-2 py-1 bg-blue-100 text-blue-800 text-[10px] font-bold rounded" data-id="element-794">
                      MUTATION
                    </span>
                    <h4 className="font-bold text-slate-800 mt-2 text-sm sm:text-base" data-id="element-795">
                      App No: MUT-2026-8891
                    </h4>
                    <p className="text-xs sm:text-sm text-slate-500" data-id="element-796">
                      LAND-002 • {t('land.dag')} 457
                    </p>
                  </div>
                  <span className="text-xs sm:text-sm font-medium text-amber-600" data-id="element-797">
                    Under Review
                  </span>
                </div>

                {/* Progress Steps */}
                <div className="relative pt-2" data-id="element-798">
                  <div className="absolute left-2 top-4 bottom-4 w-0.5 bg-slate-200" data-id="element-799"></div>
                  <div className="space-y-4" data-id="element-800">
                    <div className="relative pl-8" data-id="element-801">
                      <div className="absolute left-0 top-1 w-4 h-4 rounded-full bg-green-500 border-2 border-white" data-id="element-802"></div>
                      <p className="text-sm font-medium text-slate-800" data-id="element-803">
                        Application Submitted
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-804">10 Feb 2026</p>
                    </div>
                    <div className="relative pl-8" data-id="element-805">
                      <div className="absolute left-0 top-1 w-4 h-4 rounded-full bg-amber-500 border-2 border-white shadow-[0_0_0_2px_rgba(245,158,11,0.2)]" data-id="element-806"></div>
                      <p className="text-sm font-medium text-slate-800" data-id="element-807">
                        Under Review
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-808">
                        Currently at AC Land Office
                      </p>
                    </div>
                    <div className="relative pl-8 opacity-40" data-id="element-809">
                      <div className="absolute left-0 top-1 w-4 h-4 rounded-full bg-slate-300 border-2 border-white" data-id="element-810"></div>
                      <p className="text-sm font-medium text-slate-800" data-id="element-811">
                        Approval
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> :
        // Generic form placeholder
        <div className="space-y-4" data-id="element-812">
              <p className="text-slate-600 mb-4 text-sm" data-id="element-813">
                Please select the land you want to apply this service for:
              </p>
              <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#006A4E] outline-none text-sm" data-id="element-814">
                <option value="" data-id="element-815">Select Land...</option>
                {lands.map(l => <option key={l.id} value={l.id} data-id="element-816">
                    {l.id} ({t('land.dag')} {l.plot}, {l.district})
                  </option>)}
              </select>
            </div>}
        </div>
      </Modal>
    </div>;
}